import {useLocalStorageT} from "../hooks/useLocalStorage";
import {useClient} from "../pages/client/ClientContext";

export default function PWAInstallNotification() {

    const client = useClient()

    const [hideInstallPrompt, setHideInstallPrompt] = useLocalStorageT<boolean>("hideInstallPrompt")

    const handleInstall = async () => {
        setHideInstallPrompt(true)
        await client.doInstall()
    };

    const handleDismiss = () => {
        setHideInstallPrompt(true)
    };

    if (!client.canInstall || hideInstallPrompt) return null;

    return (
        <div className="fixed top-4 left-4 right-4 bg-primary text-white p-4 rounded-lg shadow-lg z-50 md:max-w-md md:left-auto">
            <div className="flex items-center justify-between">
                <div className="flex-1">
                    <h3 className="font-semibold">Install App</h3>
                    <p className="text-sm opacity-90">You can install this app on your device</p>
                </div>
                <div className="flex gap-2 ml-4">
                    <button
                        onClick={handleDismiss}
                        className="px-3 py-1 text-sm bg-transparent border border-white/30 rounded hover:bg-white/10"
                    >
                        Later
                    </button>
                    <button
                        onClick={handleInstall}
                        className="px-3 py-1 text-sm bg-white text-primary rounded font-medium hover:bg-gray-100"
                    >
                        Install
                    </button>
                </div>
            </div>
        </div>
    );
}
